// internal
import history from '@app/components/router/history';
import * as Action from '@app/store/typings/actions/user.d';
import * as Service from '@app/services/user';
import * as authenticationService from '@app/services/authentication';
import { handleError, convertErrorToResponse } from '@app/utils/service';
import swal from 'sweetalert2';

export function* deleteUserAccount({ payload }: Action.DeleteUserAccount) {
  try {
    const { status } = yield Service.deleteUser(payload.userId);
    if (status === 204) {
      yield authenticationService.signout();
      history.push('/brand');
      swal.fire({
        icon: 'success',
        title: 'Deleted!',
        text: 'Your account has been deleted.',
        confirmButtonColor: '#8CD4F5',
      });
    } else {
      swal.fire({
        icon: 'error',
        title: status,
        text: 'Timeout',
        confirmButtonColor: '#8CD4F5',
      });
    }
  } catch (error) {
    const message = convertErrorToResponse(error)?.message;
    swal.fire({
      icon: 'error',
      title: 'Failed',
      text: message,
      confirmButtonColor: '#8CD4F5',
    });
    handleError(error);
  }
}
